( function() {
	var secondaryHeader = document.getElementById( 'secondary-header' );

	if ( !secondaryHeader ) {
		return;
	}

	// Get initial distance for sticky element
	var topdistance = secondaryHeader.offsetTop;

	window.onscroll = function() {
		var windowdist = window.scrollY;

		// Add the sticky class
		if ( windowdist >= topdistance ) {
			secondaryHeader.classList.add( 'sticky' );

			// check for WordPress admin bar
			var adminbarTop = document.getElementById( 'wpadminbar' );

			if ( adminbarTop ) {
				secondaryHeader.classList.add( 'sticky-admin' );
			}
		} else {
			secondaryHeader.classList.remove( 'sticky' );
		}
	};
} )();
